/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelHIcon20Solid = forwardRef('ArrowParallelHIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.93 2.604a1 1 0 1 1 1.414-1.415l3.273 3.273a2.172 2.172 0 0 1 0 3.072l-3.273 3.273a1 1 0 0 1-1.414-1.415l2.394-2.394H3.75a1 1 0 1 1 0-2h10.574L11.93 2.604Z" }),
        React.createElement("path", { d: "M8.07 10.608a1 1 0 0 0-1.414-1.414l-3.273 3.273a2.172 2.172 0 0 0 0 3.071l3.273 3.273a1 1 0 0 0 1.414-1.414l-2.394-2.394H16.25a1 1 0 1 0 0-2H5.676l2.394-2.395Z" })));
});
